/**
 * Erreurs cross-origin : le navigateur remplace le message par "Script error." sans détails.
 * L'overlay react-scripts les affiche quand même ; on les stoppe en phase capture (avant l'overlay).
 */
function isOpaqueScriptError(event: ErrorEvent): boolean {
  const msg = event.message || '';
  return msg === 'Script error.' || msg === 'Script error';
}

window.addEventListener(
  'error',
  (event: Event) => {
    const e = event as ErrorEvent;
    if (!isOpaqueScriptError(e)) return;
    e.stopImmediatePropagation();
    e.preventDefault();
  },
  true,
);

export {};
